<div class="adtabcontent">
    <app-column-header [headerData]="headerData" (topbtnaction)="onSubmit()"></app-column-header>
    <form [formGroup]="createModuleForm" (ngSubmit)="onSubmit()">

        <div class="admintabfields">
            <div class="filedgrid thrcol">
                <div class="colbox">
                    <label class="control-label" for="mName">{{moduleName}}</label>
                    <input type="text" formControlName="menuName" class="formgroup" placeholder="Enter {{moduleName}}"
                        id="mName">
                </div>
                <div class="colbox ">
                        <label class="control-label">Module Order</label>
                        <input type="number" formControlName="moduleorderId" class="formgroup">
                    </div>
                <div class="colbox">
                    <label class="control-label" for="">Icon</label>
                    <ng-select class="formgroup" formControlName="menuIcon" [items]="iconListOption" bindLabel="name"
                        bindValue="id"></ng-select>
                </div>
                <div class="colbox">
                    <svg class="adicon">
                        <use [attr.xlink:href]="srcPath.menuIconPath+createModuleForm.value.menuIcon"></use>
                    </svg>
                </div>
              
            </div>
            <div class="filedgrid thrcol">
                <div class="colbox" >
                    <label class="control-label">Is Hide</label>
                    <ng-select class="form-control" palceholder="-Select-" formControlName="isHide"
                    [items]="booleanOptions" bindLabel="name"  bindValue="id" 
                    appendTo="body" ></ng-select>
                </div>
            </div>
            <div class="colbox" style="display: none;">
                <input type="checkbox" formControlName="menuLink" class="form-check-input" id="menuLinkLabel" />
                <label for="menuLinkLabel" class="form-check-label">link page</label>
            </div>
            <div class="colbox">
                <div *ngIf="createModuleForm.value.menuLink && appPageList.length>0">
                    <ng-select class="formgroup" formControlName="menuPageID" [items]="appPageList" bindLabel="name"
                        bindValue="id"></ng-select>
                </div>
            </div>
        </div>

        <!--     
    <div class="form-row">
        <div class="form-group col-md-4">
            <label for="mName" class="control-label">{{moduleName}}</label>
            <input type="text" formControlName="menuName" class="form-control" placeholder="Enter {{moduleName}}"
                id="mName">
        </div>
    </div>
    <div class="form-row">
        <div class="form-group col-md-4">
            <label for="" class="control-label">Icon</label>
            <ng-select class="form-control" formControlName="menuIcon" [items]="iconListOption" bindLabel="name"
                bindValue="id"></ng-select>
        </div>
    </div>
    <div class="form-row">
        <div class="form-group col-md-2">
            <svg class="icon iconWH">
                <use [attr.xlink:href]="srcPath.menuIconPath+createModuleForm.value.menuIcon"></use>
            </svg>
        </div>
    </div>
    <div class="form-check" style="display: none;">
        <input type="checkbox" formControlName="menuLink" class="form-check-input" id="menuLinkLabel" />
        <label for="menuLinkLabel" class="form-check-label">link page</label>
    </div>
    <div class="form-row">
        <div class="form-group col-md-4" *ngIf="createModuleForm.value.menuLink && appPageList.length>0">
            <ng-select class="form-control" formControlName="menuPageID" [items]="appPageList" bindLabel="name"
                bindValue="id"></ng-select>
        </div>
    </div>
    <div class="form-row"   >
        <div class="form-group col-md-4">
        <label class="control-label">Module Order</label>
        <input type="number" formControlName="moduleorderId" class="form-control inputText"> 
      </div>
    </div> -->

    </form>
</div>